import { TabAction, TabState } from './interfaces';

// TODO: use a shared reducer
export const getInitialState: <T>() => TabState<T> = () => ({
  crud: { open: false, record: null, mode: null },
  deleteModal: { open: false, records: [] },
});

export function reducer<T>(prevState: TabState<T>, action: TabAction<T>): TabState<T> {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...getInitialState(),
        crud: { open: true, record: action.record ?? null, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...getInitialState(),
      };
    case 'openDeleteModal':
      if (!action.records?.length) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          records: action.records,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          records: [],
        },
      };
    default:
      throw new Error('No action provided');
  }
}
